import { ButtonWithTooltip } from '../ButtonWithTooltip'
import styles from './AddTopBottomBtn.module.scss'
import addTop from '../../../assets/icons/addTop.svg'
import addBottom from '../../../assets/icons/addBottom.svg'

interface AddTopBottomBtnProps {
    btnType: 'top' | 'bottom'
    onClick: () => void
    className?: string
    disabled?: boolean
}

export const AddTopBottomBtn = (props: AddTopBottomBtnProps) => {
    const { btnType, onClick, className, disabled = false } = props
    const tooltipMsg = btnType === 'top' ? 'Insert row at top' : 'Insert row at bottom'
    const addIcon =
        btnType === 'top' ? (
            <img
                src={addTop}
                alt="Insert row at top"
            />
        ) : (
            <img
                src={addBottom}
                alt="Insert row at bottom"
            />
        )

    return (
        <ButtonWithTooltip tooltip={tooltipMsg}>
            <button
                disabled={disabled}
                onClick={onClick}
                className={`${styles.addBtn} ${className}`}
            >
                {addIcon}
            </button>
        </ButtonWithTooltip>
    )
}
